import type { ErrorConstructorOptions } from '../global';

export class DisplayableError extends Error {
  constructor(public message: string, options?: ErrorConstructorOptions) {
    super(message, options);
  }
}
